import moment from 'moment'

export function formatRelativeTime(time) {
  if (!time) return ''
  const target = moment(time)
  if (!target.isValid()) return ''
  const now = moment()
  if (now.diff(target, 'day') < 1) return target.fromNow()
  return target.format('YYYY-MM-DD HH:mm')
}

export async function downloadOssImageByUrl(url, name) {
  const urlWithoutQuery = url.split('?')[0]
  const _fileName = urlWithoutQuery.split('/').pop()?.split('.')
  const extension = (_fileName?.length || 0) > 1 ? _fileName[_fileName.length - 1] : 'png'
  let fileName = name || _fileName?.[0] || 'image'
  if (fileName && !fileName.includes('.')) {
    fileName = `${fileName}.${extension}`
  } else if (!fileName) {
    fileName = `image.${extension}`
  }
  const isInternalOss =
    url.includes('zhiyi-web.oss-cn-hangzhou.aliyuncs.com') ||
    url.includes('zhiyi-image.oss-cn-hangzhou.aliyuncs.com')
  if (isInternalOss) {
    const processedUrl = url
      .replace('zhiyi-web.oss-cn-hangzhou.aliyuncs.com', 'zhiyi-web.zhiyitech.cn')
      .replace('zhiyi-image.oss-cn-hangzhou.aliyuncs.com', 'zhiyi-image-cdn.zhiyitech.cn')
    const separator = processedUrl.includes('?') ? '&' : '?'
    const a = document.createElement('a')
    a.href = `${processedUrl}${separator}response-content-type=application/octet-stream&response-content-disposition=attachment%3Bfilename%3D${fileName}`
    a.download = fileName
    a.click()
    URL.revokeObjectURL(a.href)
  } else {
    try {
      const response = await fetch(url)
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`)
      const blob = await response.blob()
      const blobUrl = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = blobUrl
      a.download = fileName
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(blobUrl)
    } catch (error) {
      console.error('下载失败:', error)
    }
  }
}

export function downloadBlob(blob, fileName) {
  const _fileName = fileName || `${new Date().getTime()}.png`
  const a = document.createElement('a')
  a.download = _fileName
  a.href = URL.createObjectURL(blob)
  a.click()
  URL.revokeObjectURL(a.href)
}
